import * as publicBlogConstants from '../constants/publicBlogConstants'

export const publicBlogsReducer = (state = { loading: true, publicBlogs: [], type: 'NOTHING_HAPPENED' }, action) => {
  switch (action.type) {
    case publicBlogConstants.PUBLIC_BLOG_LIST_REQUEST:
      return { ...state, loading: true, type: publicBlogConstants.PUBLIC_BLOG_LIST_REQUEST };
    case publicBlogConstants.PUBLIC_BLOG_LIST_SUCCESS:
      return { ...state, loading: false, publicBlogs: action.payload.data, type: publicBlogConstants.PUBLIC_BLOG_LIST_SUCCESS };
    case publicBlogConstants.PUBLIC_BLOG_LIST_FAIL:
      return { ...state, loading: false, error: action.payload, type: publicBlogConstants.PUBLIC_BLOG_LIST_FAIL };
    case publicBlogConstants.PUBLIC_BLOG_DETAILS_REQUEST:
      return { ...state, loading: true, type: publicBlogConstants.PUBLIC_BLOG_DETAILS_REQUEST };
    case publicBlogConstants.PUBLIC_BLOG_DETAILS_SUCCESS:
      return { ...state, loading: false, publicBlog: action.payload.data, type: publicBlogConstants.PUBLIC_BLOG_DETAILS_SUCCESS };
    case publicBlogConstants.PUBLIC_BLOG_DETAILS_FAIL:
      return { ...state, loading: false, error: action.payload, type: publicBlogConstants.PUBLIC_BLOG_DETAILS_FAIL };
    case publicBlogConstants.PUBLIC_BLOG_DELETE_REQUEST:
      return { ...state, loading: true, type: publicBlogConstants.PUBLIC_BLOG_DELETE_REQUEST };
    case publicBlogConstants.PUBLIC_BLOG_DELETE_SUCCESS:
      return { ...state, loading: false, type: publicBlogConstants.PUBLIC_BLOG_DELETE_SUCCESS };
    case publicBlogConstants.PUBLIC_BLOG_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload.data, type: publicBlogConstants.PUBLIC_BLOG_DELETE_FAIL };
    case publicBlogConstants.PUBLIC_BLOG_UPDATE_REQUEST:
      return { ...state, loading: true, type: publicBlogConstants.PUBLIC_BLOG_UPDATE_REQUEST };
    case publicBlogConstants.PUBLIC_BLOG_UPDATE_SUCCESS:
      return { ...state, loading: false, type: publicBlogConstants.PUBLIC_BLOG_UPDATE_SUCCESS };
    case publicBlogConstants.PUBLIC_BLOG_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload, type: publicBlogConstants.PUBLIC_BLOG_UPDATE_FAIL };
    case publicBlogConstants.PUBLIC_BLOG_CREATE_REQUEST:
      return { ...state, loading: true, type: publicBlogConstants.PUBLIC_BLOG_CREATE_REQUEST };
    case publicBlogConstants.PUBLIC_BLOG_CREATE_SUCCESS:
      return { ...state, loading: false, type: publicBlogConstants.PUBLIC_BLOG_CREATE_SUCCESS };
    case publicBlogConstants.PUBLIC_BLOG_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload, type: publicBlogConstants.PUBLIC_BLOG_CREATE_FAIL };
    default:
      return state;
  }
}